import type { Messages } from './en.ts';

export const ru: Messages = {
  app: {
    name: 'Salt & Shot',
    shortName: 'Salt & Shot',
    subtitle: 'Морская тактика',
    tagline: 'Тактическая игра под парусами и паром',
    skipToContent: 'Перейти к содержимому',
    loading: 'Берём промеры…',
  },
  nav: {
    label: 'Главная навигация',
    profile: 'Профиль',
    logbook: 'Вахтенный журнал',
    harbour: 'Гавань',
    newGame: 'Новая игра',
    comingSoon: 'скоро',
    newGameFailed: 'Не удалось начать игру. Попробуйте ещё раз.',
    signIn: 'Войти',
    join: 'Вступить во флот',
    signOut: 'Выйти',
    language: 'Язык',
  },
  landing: {
    pageTitle: 'Salt & Shot',
    chartTitle: 'Новая и верная карта',
    chartSubtitle: 'тактики паруса и пара',
    lead: 'Командуйте флотилией бригов, фрегатов и колёсных пароходов. Читайте ветер, остерегайтесь рифов и пушек фортов и приведите корабли в Королевский порт.',
    features: {
      wind: 'Вертушка ветра решает, кто идёт под парусами, а кому лавировать.',
      steam: 'Парус и ранний пар в одном флоте: скорость против наветренного положения.',
      ports: 'Форты, порты и Королевский порт определяют каждый бой.',
    },
    playGuest: 'Сыграть против компьютера',
    playGuestNote: 'Без регистрации: малая карта, против компьютера.',
    published: 'Гравировано для Адмиралтейства ни одной определённой державы',
  },
  profile: {
    pageTitle: 'Профиль капитана',
    title: 'Профиль капитана',
    particulars: 'Сведения о капитане',
    serviceSince: 'На службе с {{date}}',
    lastSeen: 'Последний раз на борту {{date}}',
    email: 'Эл. почта',
    emailUnknown: 'Эл. почта не указана',
    register: 'Судовая книга',
    registerHint: 'Так вас увидят другие капитаны в списках флота.',
    nickname: 'Псевдоним',
    nicknameHint: '3–20 букв, цифр, «_» или «-». Должен быть уникальным во флоте.',
    displayName: 'Имя',
    displayNameHint: 'Показывается рядом с псевдонимом. До 40 символов.',
    save: 'Внести в книгу',
    saving: 'Записываем…',
    saved: 'Внесено в книгу.',
    languageTitle: 'Язык',
    languageHint: 'Язык карт, журналов и приказов. Сохраняется в вашем профиле.',
    loadFailed: 'Не удалось получить ваши бумаги. Возможно, потерян сигнал — попробуйте чуть позже.',
    retry: 'Попробовать снова',
  },
  avatars: {
    'pennant-yellow': 'Жёлтый вымпел',
    'pennant-green': 'Зелёный вымпел',
    'pennant-crimson': 'Багряный вымпел',
    'pennant-slate': 'Сизый вымпел',
    'burgee-gold': 'Золотой брейд-вымпел',
    'burgee-blue': 'Синий брейд-вымпел',
    'signal-alpha': 'Сигнальный флаг «Альфа»',
    'signal-bravo': 'Сигнальный флаг «Браво»',
    'signal-delta': 'Сигнальный флаг «Дельта»',
    'signal-kilo': 'Сигнальный флаг «Кило»',
    'signal-november': 'Сигнальный флаг «Новембер»',
    'signal-papa': 'Сигнальный флаг «Папа»',
    'signal-uniform': 'Сигнальный флаг «Юниформ»',
    'signal-zulu': 'Сигнальный флаг «Зулу»',
  },
  newGame: {
    title: 'Новая игра',
    close: 'Закрыть',
    how: 'Как играть',
    fleet: { red: 'Ваш флот', blue: 'Флот противника', colour: 'Цвет' },
    bot: { name: 'Против компьютера', hint: 'Вы ведёте первый флот, компьютер отвечает сразу.' },
    online: {
      name: 'С другом по сети',
      hint: 'Вы получите ссылку для друга; игра начнётся, когда он её примет.',
    },
    hotseat: {
      name: 'Вдвоём за одним экраном',
      hint: 'Оба флота на этом устройстве; передавайте его каждый ход.',
    },
  },
  logbook: {
    pageTitle: 'Вахтенный журнал',
    title: 'Вахтенный журнал',
    lead: 'Ваши походы и сражения, записанные по датам.',
    emptyTitle: 'Стоим на якоре',
    emptyBody:
      'В журнал ещё не внесено ни одного похода. Начните игру — и ваши сражения будут записаны здесь.',
    columns: {
      opponent: 'Соперник',
      status: 'Состояние',
      turn: 'Ход',
      updated: 'Последняя запись',
    },
    openInvite: 'Ожидаем соперника',
    hotseat: 'За одним экраном: оба флота',
    bot: 'Против компьютера',
    open: 'Открыть',
    status: {
      pending: 'Сбор',
      active: 'В походе',
      finished: 'Завершена',
      abandoned: 'Брошена',
    },
    turn: {
      mine: 'Ваш ход',
      theirs: 'Ход соперника',
      none: '—',
    },
    side: {
      yellow: 'Жёлтый флот',
      green: 'Зелёный флот',
    },
  },
  harbour: {
    pageTitle: 'Гавань',
    title: 'Добро пожаловать на борт',
    welcome: 'Добро пожаловать на борт, {{rank}} {{name}}',
    watches: {
      middle: 'Собачья вахта',
      morning: 'Утренняя вахта',
      forenoon: 'Предполуденная вахта',
      afternoon: 'Послеполуденная вахта',
      firstDog: 'Первая полувахта',
      lastDog: 'Вторая полувахта',
      first: 'Вечерняя вахта',
    },
    bells: {
      b1: 'одна склянка',
      b2: 'две склянки',
      b3: 'три склянки',
      b4: 'четыре склянки',
      b5: 'пять склянок',
      b6: 'шесть склянок',
      b7: 'семь склянок',
      b8: 'восемь склянок',
    },
    ranks: {
      midshipman: 'мичман',
      lieutenant: 'лейтенант',
      commander: 'капитан-лейтенант',
      captain: 'капитан',
      commodore: 'коммодор',
      rearAdmiral: 'контр-адмирал',
    },
    helm: {
      kicker: 'На мостике',
      yourMove: 'Ждём ваших приказов',
      theirMove: 'Ход противника',
      turn: 'ход {{n}}',
      lastEntry: 'Последняя запись в журнале — {{when}}.',
      take: 'Встать к штурвалу',
      look: 'Взглянуть на карту',
      more: 'Ещё игр ждут ваших приказов: {{n}}',
      calmTitle: 'На палубе тихо',
      calmBody: 'Сражений сейчас нет. Выберите флоты и выходите в море.',
    },
    record: {
      title: 'Послужной список',
      voyages: 'Походов',
      underWay: 'В море',
      concluded: 'Завершено',
      rank: 'Звание',
      next: 'Следующее: {{rank}}, после {{n}} завершённых сражений.',
      openLog: 'Открыть вахтенный журнал',
    },
    order: {
      title: 'Приказ по флоту',
      signed: 'Адмирал',
      next: 'Следующий приказ',
    },
    orders: {
      o1: 'Включайте в эскадру только те корабли, что пойдут в ход: остальные стоят на месте и всё равно могут стрелять.',
      o2: 'Свежий ветер быстрее всего несёт по ветру; каждый румб к ветру стоит клетки.',
      o3: 'Обходите форты стороной, если не собираетесь заставить их пушки замолчать.',
      o4: 'Повреждённый корабль в своём порту может встать в док, если не стрелял: каждый ход заделывается одна пробоина.',
      o5: 'Помните о рифах — на карте они красные: через них не пройдёт ни один киль.',
      o6: 'Наведите курсор на врага перед манёвром: карта покажет, чьи пушки до него достанут.',
      o7: 'Королевский порт противника — главный приз. Держите корабль-другой у своего.',
      o8: 'Пару ветер не указ: держите пароход под рукой на случай штиля.',
      o9: 'Залп бросает кости один раз на все пушки: попадание пробивает все дыры разом, промах губит все выстрелы. Им топят большой корабль с одного удара.',
      o10: 'Невыпущенные ядра пропадают в конце хода: если цель в пределах выстрела, стреляйте.',
      o11: 'У рифов ходите малой эскадрой: шторм гонит только собранные корабли, а риф разбивает любого, кого поймает.',
      o12: 'Корабль на Королевском порту противника не стреляет. Не берите его в эскадру — и шторм его не сдвинет.',
      o13: 'Павший форт не потерян навсегда: займите порт своими кораблями, без врага рядом, — и над фортом поднимется ваш флаг.',
      o14: 'Если форт падёт, все корабли в его доке идут ко дну. Становитесь в док только за крепким фортом.',
      o15: 'Земля и форты закрывают выстрел, корабли и рифы — нет. Найдите чистую линию, прежде чем сближаться.',
      o16: 'В штиль паруса висят, а вёсла и пар идут в любую сторону: штиль — час галеры.',
      o17: 'Два корабля на морскую клетку, один — на прибрежную: выберите стоянку до того, как поднять паруса, иначе не дойдёте.',
      o18: 'Пока форт стоит, ни один враг не войдёт в ваш порт: целый форт — лучшие ворота.',
    },
  },
  invite: {
    against: 'против',
    waiting: {
      pageTitle: 'Ждём соперника',
      kicker: 'Игра по сети',
      title: 'Ждём соперника',
      body: 'Отправьте эту ссылку капитану, с которым хотите сразиться. Игра откроется здесь, как только он её примет.',
      linkLabel: 'Ссылка-приглашение',
      copy: 'Скопировать ссылку',
      copied: 'Скопировано',
      expires: 'Ссылка действует до {{date}}.',
      notYours: 'Ждём, пока второй капитан примет приглашение.',
    },
    join: {
      pageTitle: 'Вызов на бой',
      kicker: 'Игра по сети',
      title: 'Вызов на бой',
      body: 'Капитан {{name}} вызывает вас на бой. Вы поведёте второй флот.',
      own: 'Это ваше собственное приглашение: отправьте ссылку капитану, с которым хотите сразиться.',
      signIn: 'Войти и принять',
      signUp: 'Вступить во флот',
      accept: 'Принять командование',
      open: 'Открыть игру',
      home: 'На титульную страницу',
      missing: 'Такого приглашения нет. Проверьте ссылку.',
      taken: 'Это приглашение уже принял другой капитан.',
      expired: 'Приглашение больше не действует. Попросите новую ссылку.',
      failed: 'Не удалось принять приглашение. Попробуйте ещё раз.',
    },
  },
  notFound: {
    pageTitle: 'Неизведанные воды',
    title: 'Неизведанные воды',
    body: 'Здесь ещё никто не делал промеров, и этой страницы нет ни на одной нашей карте.',
    back: 'Вернуться в порт',
  },
  error: {
    title: 'Штормит',
    body: 'На борту что-то пошло не так. Попробуйте ещё раз.',
    reload: 'Обновить',
    authTitle: 'Не удалось подняться на борт',
    authBody: 'Вход не завершён. Попробуйте ещё раз.',
  },
  errors: {
    nickname_taken: 'Под этим псевдонимом уже ходит другой капитан.',
    validation_failed: 'Проверьте отмеченные поля.',
    unauthorized: 'Сеанс завершён. Войдите снова.',
    network: 'Берег не отвечает. Проверьте соединение и попробуйте ещё раз.',
    generic: 'Что-то пошло не так. Попробуйте ещё раз.',
    nickname_charset: 'Только буквы, цифры, «_» или «-».',
    too_short: 'Слишком коротко.',
    too_long: 'Слишком длинно.',
  },
  ships: {
    names: {
      first_rate: 'Линейный трёхпалубный, 100 пушек',
      ship_of_line: 'Линейный двухпалубный, 60 пушек',
      sail_frigate: 'Парусный фрегат',
      brig: 'Бриг',
      cutter: 'Тендер',
      galleon: 'Галеон',
      galley: 'Галера',
      ironclad_battery: 'Броненосная батарея',
      steam_frigate: 'Паровой фрегат',
      steam_corvette: 'Паровой корвет',
      paddle_steamer: 'Пароход',
      monitor: 'Монитор',
    },
    guns: {
      first_rate: '100 пушек',
      ship_of_line: '60 пушек',
      sail_frigate: '40 пушек',
      brig: '14 пушек',
      cutter: '8 пушек',
      galleon: '30 пушек',
      galley: '8 пушек',
      ironclad_battery: '40 тяжёлых пушек',
      steam_frigate: '30 пушек',
      steam_corvette: '20 пушек',
      paddle_steamer: '10 пушек',
      monitor: '2 тяжёлые башенные пушки',
    },
    sides: {
      red: 'Жёлтый флот',
      blue: 'Зелёный флот',
    },
    token: {
      label: '{{ship}}, {{nation}}',
      damage: 'пробоин: {{damage}} из {{max}}',
      sunk: 'потоплен',
      anchored: 'на якоре',
      repairing: 'в ремонте',
    },
    card: {
      label: 'Карточка: {{ship}}',
      alt: 'Акварельная иллюстрация: {{ship}}',
      stats: 'Характеристики',
      fresh: 'Свежий ветер',
      calm: 'Штиль',
      storm: 'Снос в бурю',
      cannotMove: 'не ходит',
      shots: 'Выстрелов за ход',
      range: 'Дальность',
      sinksAt: 'Пробоин до потопления',
      holes: 'Пробоины',
      status: {
        sunk: 'Потоплен',
        repairing: 'В доке, ремонт',
        anchored: 'На якоре в порту',
        repairingFort: 'Чинит форт',
        ready: 'Готов',
      },
    },
  },
  game: {
    load: {
      failed: 'Не удалось загрузить игру.',
      notFound: 'В вашем журнале нет такой игры.',
      retry: 'Попробовать ещё раз',
      back: 'В журнал',
    },
    turn: 'Ход {{n}}',
    toAct: 'Ходит: {{side}}',
    phase: {
      handover: 'Передача хода',
      replay: 'Повтор',
      waiting: 'Ход соперника',
      muster: 'Выбор эскадры',
      wind: 'Ветер',
      battle: 'Манёвр и огонь',
      over: 'Игра окончена',
    },
    prompt: {
      handover: 'Передайте устройство игроку: {{side}}.',
      portMove:
        'Нажмите на подсвеченную стоянку, чтобы переставить корабль в порту. Это его ход на этот ход.',
      replay: 'Последний ход противника, шаг за шагом.',
      waiting: 'Ходит {{side}}. Вы увидите его ход по мере того, как он идёт.',
      musterEmpty: 'Нажимайте на корабли на карте, чтобы собрать эскадру.',
      musterChosen: 'Выйдут в море: {{n}}. Бросьте ветер, когда будете готовы.',
      wind: 'Бросаем ветер…',
      battleMove:
        'Нажмите на корабль с ⛵, чтобы его передвинуть, или выберите корабль и нажмите на противника, чтобы выстрелить.',
      battleReach: 'Нажмите на подсвеченную клетку, чтобы перейти туда.',
      battleIdle: 'Стреляйте или завершите ход.',
      endSummary: 'Не все ваши корабли и форты сделали своё.',
      fire: 'Выберите, кто стреляет, и стреляйте.',
      over: 'Игра окончена.',
    },
    action: {
      cast: 'Бросить ветер (кораблей: {{n}})',
      castWind: 'Бросить ветер',
      portMove: 'Переставить в порту',
      portMoveCancel: 'Отменить перестановку',
      portMoveHint: 'Это ход корабля на этот ход: с эскадрой он уже не пойдёт.',
      skipSailing: 'Не двигаться, сразу к огню',
      raiseSails: 'Поднять паруса',
      endTurn: 'Завершить ход',
      keepPlaying: 'Продолжить ход',
      undo: 'Отменить',
      undoNothing: 'Нечего отменять после последнего ветра, выстрела или хода.',
      allToSea: 'Все в море',
      allExceptPort: 'Все, кроме стоящих в порту',
      clear: 'Очистить',
      startTurn: 'Начать ход',
      skipAnimation: 'Продолжить',
      noReturn: 'Нельзя отменить',
      addToSquadron: 'Добавить в эскадру',
      removeFromSquadron: 'Убрать из эскадры',
    },
    confirmCast: {
      title: 'Бросить ветер?',
      body: 'Ветер бросается один раз за ход, для всей эскадры. Корабли не из эскадры в этот ход не двигаются — но стрелять смогут. Отменить бросок нельзя.',
      confirm: 'Бросить ветер',
      back: 'Назад',
      dontAsk: 'Больше не спрашивать',
    },
    handover: {
      title: 'Ход: {{side}}',
      first: 'Первый ход: {{side}}.',
      firstByLot: 'Жребий брошен: первый ход — {{side}}.',
    },
    wind: {
      fresh: 'Свежий ветер, дует на {{dir}}: быстрее всего идти по ветру.',
      calm: 'Штиль: двигаться могут только гребные и паровые суда.',
      storm: 'Буря, несёт на {{dir}}: эскадру сносит по ветру.',
      movers: 'Могут пойти: {{n}} из {{total}}.',
      title: 'Ветер',
    },
    weather: {
      fresh: 'Свежий ветер',
      calm: 'Штиль',
      storm: 'Буря',
    },
    dir: {
      N: 'север',
      NE: 'северо-восток',
      E: 'восток',
      SE: 'юго-восток',
      S: 'юг',
      SW: 'юго-запад',
      W: 'запад',
      NW: 'северо-запад',
    },
    fire: {
      inSights: 'Под прицелом: стрелков {{n}}, выстрелов {{shots}}',
      title: 'Огонь по цели: {{target}}',
      holes: 'Пробоины: {{n}} из {{max}}',
      fortHits: 'Попадания: {{n}} из {{max}}',
      shots: 'выстрелов: {{n}}',
      distance: 'дистанция {{n}}',
      fewer: 'Меньше выстрелов: {{unit}}',
      more: 'Больше выстрелов: {{unit}}',
      staysInPort: 'до конца хода останется в порту',
      sinks: 'попадание потопит цель',
      holesAfter: 'при попадании: {{n}} пробоин из {{max}}',
      destroys: 'попадание разрушит форт',
      hitsAfter: 'при попадании: {{n}} попаданий из {{max}}',
      volley: 'Залп (орудий: {{n}})',
      oneByOne: 'Стрелять по одному',
      shoot: 'Огонь',
      stop: 'Стоп',
      close: 'Закрыть',
      noReturn: 'Выстрел нельзя отменить',
      hit: 'Попадание!',
      miss: 'Промах.',
      none: 'Выберите, кто стреляет.',
    },
    unit: {
      named: '«{{name}}»',
      ship: '{{cls}} №{{n}}',
      fortFirst: 'Форт первой линии {{n}}',
      fortSecond: 'Форт второй линии {{n}}',
      fort: 'Форт {{name}}',
      fortClass: {
        first_line: 'Форт первой линии',
        second_line: 'Форт второй линии',
      },
    },
    log: {
      title: 'Журнал',
      turn: 'Ход {{n}} · {{side}}',
      wind: '{{side}}: ветер брошен для кораблей: {{n}}. {{weather}}, на {{dir}}.',
      drift: '{{ship}}: буря снесла {{from}} → {{to}}.',
      sailed: '{{ship}}: переход {{from}} → {{to}}.',
      inPort: '{{ship}}: перешёл внутри порта на {{to}}.',
      anchored: '{{ship}}: выброшен к берегу у {{cell}}, стал на якорь.',
      wrecked: '{{ship}}: разбит о риф у {{cell}}.',
      shot: '{{shooter}}: выстрел по цели {{target}} — {{result}}.',
      volley: 'Залп из {{n}} орудий ({{shooters}}) по цели {{target}} — {{result}}.',
      miss: 'промах',
      hit: 'попадание',
      holes: 'попадание, пробоин {{n}} из {{max}}',
      sunk: 'попадание, потоплен',
      fortHits: 'попадание, {{n}} из {{max}}',
      destroyed: 'попадание, форт разрушен',
      sunkInDock: '{{ship}}: затонул в доке вместе с фортом.',
      dock: '{{ship}}: в доке, ремонт ходов: {{n}}.',
      repaired: '{{ship}}: отремонтирован, пробоин осталось {{n}}.',
      dockLeft: '{{ship}}: вышел из дока, готов к походу.',
      fortRepair: '{{side}}: начат ремонт — {{fort}}.',
      fortRepairStopped: {
        voluntary: '{{fort}}: ремонт остановлен.',
        crew_lost: '{{fort}}: ремонт остановлен, команда погибла.',
        fort_destroyed: '{{fort}}: ремонт остановлен, форт разрушен.',
        completed: '{{fort}}: ремонт закончен.',
      },
      fortRepaired: '{{fort}}: отремонтирован, повреждений осталось {{n}}.',
      captured: '{{fort}}: теперь под флагом — {{side}}.',
      royalHold: '{{side}}: Королевский порт противника удерживается, {{n}} из {{max}}.',
      royalLost: '{{side}}: Королевский порт противника потерян.',
      drawOffered: '{{side}}: предложена ничья.',
      drawExpired: '{{side}}: предложение ничьей истекло.',
      drawAccepted: '{{side}}: ничья принята.',
      resigned: '{{side}}: сдача.',
      endTurn: '{{side}}: ход завершён.',
      show: 'Показать на карте',
      empty: 'Пока ничего не произошло.',
      filter: {
        all: 'Все',
        wind: 'Ветер',
        move: 'Движение',
        fire: 'Стрельба',
        repair: 'Ремонт и захват',
        turn: 'Ходы',
      },
      export: 'Экспорт',
    },
    roster: {
      title: 'Флот',
      mine: 'Ваш флот',
      theirs: 'Противник',
      forts: 'Форты',
      afloat: 'на плаву {{n}} из {{total}}',
      filter: {
        label: 'Показать',
        canAct: 'Могут действовать',
        all: 'Все',
        squadron: 'Эскадра',
        damaged: 'Повреждённые',
        inPort: 'В порту',
      },
      status: {
        inSquadron: 'в эскадре',
        toMove: 'может пойти',
        moved: 'ходил',
        fired: 'стрелял',
        shots: 'выстрелов {{n}}',
        dock: 'в доке {{n}}',
        crew: 'чинит форт',
        inPort: 'в порту',
        sunk: 'потоплен',
        destroyed: 'разрушен',
      },
      none: 'Таких кораблей нет.',
    },
    view: {
      tools: 'Вид',
      myFleet: 'Мой флот',
      chart: 'Карта сверху',
      perspective: 'Перспектива',
      log: 'Журнал',
      keys: 'Клавиши',
      show: 'Показать',
    },
    keys: {
      title: 'Клавиатура',
      close: 'Закрыть',
      space: 'Бросить ветер · пропустить анимацию',
      tab: 'Следующий / предыдущий корабль, который может действовать',
      arrows: 'Курсор по клеткам (если выбран корабль) · сдвиг карты',
      enter: 'Бросить ветер · ход к курсору · огонь · завершить ход',
      f: 'Навести выбранный корабль на следующую цель',
      v: 'Залп: все, кто достаёт до цели',
      s: 'Добавить выбранный корабль в эскадру или убрать',
      a: 'Все корабли, что могут выйти в море, — в эскадру, или ни одного',
      z: 'Отменить',
      r: 'Посмотреть последний ход противника',
      i: 'Карточка выбранного корабля',
      esc: 'Закрыть · снять выбор',
      m: 'Мой флот',
      c: 'Карта сверху',
      l: 'Журнал',
      plusMinus: 'Масштаб',
      help: 'Этот список',
    },
    replay: {
      watch: 'Посмотреть ход: {{side}}',
      title: 'Повтор хода: {{side}}',
      step: 'Шаг {{n}} из {{total}}',
      pause: 'Пауза',
      play: 'Дальше',
      skip: 'Пропустить',
      speed: 'Скорость',
    },
    caption: {
      portMoved: 'Переставлен в порту',
      wrecked: 'Разбит!',
      sunk: 'Потоплен!',
      destroyed: 'Форт разрушен!',
      repaired: 'Ремонт: осталось {{n}}',
    },
    board: {
      zoomIn: 'Приблизить',
      zoomOut: 'Отдалить',
      fit: 'Вся карта',
      minimapShow: 'Показать мини-карту',
      minimapHide: 'Скрыть мини-карту',
    },
    chart: {
      fort: 'Форт',
      royalPort: 'Королевский порт',
    },
    sheet: {
      close: 'Закрыть',
      view: 'Вид',
      picker: 'Какой корабль?',
      more: 'Ещё',
      card: 'Карточка',
    },
    hud: {
      status: 'Состояние хода',
      tools: 'Меню игры',
      fleet: 'Флот',
      log: 'Журнал',
      minimap: 'Мини-карта',
      menu: 'Меню',
      help: 'Справка',
      ships: 'Кораблей на плаву: {{n}} из {{total}}',
      forts: 'Фортов уцелело: {{n}} из {{total}}, повреждено: {{damaged}}',
      royalHold: 'Удержание вражеского Королевского порта: {{n}} из {{max}}',
      settings: 'Настройки',
    },
    inspector: {
      state: 'Состояние',
      specs: 'Характеристики',
      holes: 'Пробоины',
      holesValue: '{{n}} из {{max}}',
      shotsLeft: 'Выстрелы',
      shotsValue: 'осталось {{n}} из {{max}}',
      sailing: 'Движение',
      moveAvailable: 'До {{n}} клеток',
      moveDone: 'Выполнено',
      moveRepair: 'На ремонте',
      repair: 'Ремонт',
      repairDock: 'В доке: осталось ходов — {{n}}',
      repairCrew: 'Команда чинит {{fort}}',
      repairFort: 'Ремонт форта: осталось ходов — {{n}}',
      squadron: 'Эскадра',
      guns: 'Вооружение',
      shotsPerTurn: 'Выстр. за ход',
      range: 'Дальность',
      cells: '{{n}} кл.',
      fresh: 'Свежий ветер',
      calm: 'Штиль',
      storm: 'Снос в бурю',
      noCalm: '—',
      sinksAt: 'Тонет от',
      sinksAtValue: '{{n}} пробоин',
      hits: 'Попадания',
      expand: 'Подробнее',
      collapse: 'Свернуть',
      close: 'Закрыть',
      sunk: 'Потоплен',
      destroyed: 'Разрушен',
      moveNoSquadron: 'Не в эскадре',
      moveAfterWind: 'После броска ветра',
      moveBecalmed: 'Штиль: стоит',
      moveStorm: 'Снесён бурей',
      moveBlocked: 'Путь закрыт',
      moveNotNow: 'Не сейчас',
    },
    unitPanel: {
      holes: 'Пробоины: {{n}} из {{max}}',
      hits: 'Попадания: {{n}} из {{max}}',
      royalHold: 'Королевский порт: {{n}} из {{max}}, осталось {{left}}',
      shooters: 'Ваших в пределах выстрела: {{n}}',
      outOfReach: 'Вне досягаемости всех ваших кораблей и фортов.',
      move: 'Идти',
      fire: 'Огонь',
      fireAt: 'Огонь по нему',
      centre: 'К нему',
      deselect: 'Снять выбор',
      dock: 'Ремонт в доке',
      fortRepair: 'Чинить форт ({{n}} корабля)',
      fortRepairStop: 'Прекратить ремонт',
      enemy: 'враг',
      note: {
        afterWind: 'Пойдёт, как только будет брошен ветер.',
        chooseToSail: 'Добавьте в эскадру, чтобы он пошёл в этот ход.',
        noTargets: 'Врага в пределах выстрела нет.',
        noRoom: 'Отсюда некуда идти.',
      },
    },
    reach: {
      blocked: '{{cell}}: {{why}}',
    },
    menu: {
      title: 'Меню',
      newGame: 'Новая партия…',
      settings: 'Настройки',
      game: 'Игра',
      developer: 'Разработчику',
      chart: 'Вид карты (плоской, проще попадать)',
      watercolour: 'Акварельная карта',
      confirmCast: 'Спрашивать перед броском ветра',
      offerDraw: 'Предложить ничью',
      acceptDraw: '{{side}} принимает ничью',
      resign: '{{side}} сдаётся',
    },
    size: {
      label: 'Размер партии',
      start: 'Начать: {{size}}',
      small: { name: 'Малая партия', counts: '6 кораблей / 2 форта', blurb: 'Компактное морское сражение.' },
      medium: {
        name: 'Средняя партия',
        counts: '12 кораблей / 4 форта',
        blurb: 'Тактическое сражение нескольких эскадр.',
      },
      large: {
        name: 'Большая партия',
        counts: '28 кораблей / 6 фортов',
        blurb: 'Полномасштабная морская кампания.',
      },
      classic: 'Классическая карта',
    },
    help: {
      title: 'Справка',
      turn: 'Как идёт ход',
      steps: {
        muster: {
          title: 'Выберите эскадру',
          body: 'касайтесь своих кораблей на карте, чтобы назвать, кто пойдёт в этот ход; выбранные отмечены галочкой, повторное касание снимает выбор.',
        },
        wind: {
          title: 'Бросьте ветер',
          body: 'одна вертушка на всю эскадру: свежий ветер, штиль или буря, и его направление.',
        },
        battle: {
          title: 'Манёвр и огонь',
          body: 'выберите корабль: синие клетки — куда он может пойти, красные метки — в кого попадёт. Движение и огонь — в любом порядке.',
        },
        end: { title: 'Завершите ход', body: 'и ход перейдёт к другой стороне.' },
      },
      select: 'Два корабля в одной клетке',
      selectBody:
        'Касание клетки с двумя кораблями открывает небольшой список: выберите нужный. Выбранный корабль обведён синим, вражеский — красным.',
    },
    chartHint: {
      title: 'Перейти на карту сверху?',
      body: 'На маленьком экране по клеткам плоской карты попадать легче. Вернуться можно в любой момент кнопкой «Карта сверху».',
      switch: 'Карта сверху',
      keep: 'Оставить перспективу',
    },
    summary: {
      title: 'Завершить ход?',
      notMoved: 'Ещё не ходили: {{n}}',
      notFired: 'Ещё могут стрелять: {{n}}',
    },
    squadron: {
      title: 'Эскадра',
      in: 'В эскадре',
      out: 'В этот ход стоит на месте',
      cannot: 'Не может двигаться в этот ход',
      count: 'Эскадра: {{n}} из {{total}}',
      list: 'Выбрать из списка',
    },
    over: {
      winner: '{{side}} побеждает',
      victory: 'Победа!',
      defeat: 'Поражение',
      end: 'Игра окончена',
      turn: 'Ход',
      afloat: '{{side}}: на плаву',
      close: 'Посмотреть на карту',
      leave: 'Выйти',
      won: 'Победа: {{side}}',
      royal_port: 'Королевский порт удержан.',
      annihilation: 'Все корабли противника потоплены.',
      resignation: 'Противник сдался.',
      draw: 'Ничья по соглашению',
    },
  },
  why: {
    generic: 'Правила этого не позволяют ({{rule}}).',
    gameOver: 'Игра окончена.',
    invalidAction: 'Так сделать нельзя.',
    unknownUnit: 'Такого корабля или форта нет.',
    notYourTurn: 'Сейчас ход другой стороны.',
    notYourUnit: 'Это не ваш корабль или форт.',
    noDrawOffer: 'Предложения ничьей нет.',
    groupAlreadyCast: 'Ветер в этот ход уже брошен.',
    invalidGroup: 'Выберите хотя бы один корабль.',
    noSquadron: 'Сначала выберите эскадру, затем бросайте ветер.',
    windNotCast: 'Сначала бросьте ветер: корабли двигаются только после него.',
    castWindFirst: 'Сначала бросьте ветер для выбранной эскадры.',
    notInSquadron: 'Этот корабль не в эскадре и в этот ход не двигается. Стрелять он может.',
    inSquadron: 'Корабли эскадры идут по ветру, а не внутри порта.',
    stormDrifted: 'Буря уже снесла этот корабль — это и был его ход.',
    becalmed: 'Штиль: парусник без ветра не движется.',
    sunk: 'Этот корабль потоплен.',
    inDock: 'Корабль в доке, на ремонте.',
    alreadyInDock: 'Корабль уже в доке.',
    onFortRepair: 'Корабль чинит форт.',
    alreadyMoved: 'Корабль уже сделал свой ход.',
    firedInPort: 'Корабль стрелял из порта и до конца хода остаётся в нём.',
    notInLine: 'Корабли ходят и стреляют только по прямой: по строке, столбцу или диагонали.',
    tooFar: 'Слишком далеко против этого ветра.',
    blockedByLand: 'На пути суша.',
    blockedByReef: 'На пути риф.',
    ownRoyalPort: 'Свои корабли не заходят в свой Королевский порт.',
    enemyPort: 'Порт охраняет вражеский форт — сначала разрушьте его.',
    cellFull: 'В этой клетке нет места.',
    portFull: 'Порт полон.',
    diagonalSqueeze: 'Проход между берегами слишком узок.',
    shipInTheWay: 'На пути другой корабль.',
    notInOwnPort: 'Корабль не в вашем защищённом порту.',
    notInThisPort: 'Переставить корабль можно только на другое место в том же порту.',
    invalidShots: 'Каждый стрелок должен сделать хотя бы один выстрел.',
    noShotsLeft: 'Выстрелов в этот ход не осталось.',
    cannotFireInDock: 'Корабль в доке не стреляет.',
    cannotFireOnRepair: 'Корабль, чинящий форт, не стреляет.',
    onEnemyRoyalPort: 'Корабль в Королевском порту противника не стреляет.',
    fortDestroyed: 'Форт разрушен.',
    outOfRange: 'Слишком далеко для выстрела.',
    lineOfFireBlocked: 'Линию огня закрывает суша.',
    friendlyTarget: 'Это ваш корабль или форт.',
    fortCannotTargetFort: 'Форты стреляют только по кораблям.',
    targetGone: 'Цель уже потоплена или разрушена.',
    volleyTooFewShooters: 'Для залпа нужно не меньше {{n}} кораблей или фортов.',
    notDamaged: 'Чинить нечего: повреждений нет.',
    firedThisTurn: 'Корабль, стрелявший в этот ход, не может начать ремонт.',
    alreadyRepairing: 'Ремонт уже идёт.',
    enemiesInPort: 'В порту корабли противника.',
    notYourFort: 'Это не ваш форт.',
    wrongCrewSize: 'Для ремонта форта нужна команда ровно из {{n}} кораблей.',
    crewNotInPort: 'Команда должна стоять в порту форта.',
    noRepairHere: 'Вы не чините этот форт.',
  },
  learn: {
    pageTitle: 'Как играть',
    title: 'Как играть',
    lead: 'Правила Salt & Shot вкратце: по странице на каждую часть игры.',
    open: 'Как играть',
    contents: 'Содержание',
    picture: 'Пример на карте: {{topic}}',
    rules: 'Правила: {{ids}}',
    back: 'Вернуться в гавань',
    hintMore: 'Подробнее…',
    hintGotIt: 'Понятно',
    hintsOn: 'Показывать подсказки',
    hintsReset: 'Показать все подсказки заново',
    hints: {
      muster: {
        title: 'Выберите эскадру',
        body: 'Нажмите на корабли, которые пойдут в этот ход, затем бросьте ветер. После ветра двигается только эскадра; остальные могут стрелять.',
      },
      wind: {
        title: 'Ветер брошен',
        body: 'Выберите корабль эскадры: синие клетки — куда он может пойти. При свежем ветре быстрее всего идти по ветру, куда указывает стрелка; каждые 45° против ветра отнимают клетку.',
      },
      becalmed: {
        title: 'Не каждый корабль может идти',
        body: 'В штиль двигаются только гребные и паровые суда, а встречный ветер может не оставить паруснику ни одной клетки. Стрелять он всё равно может.',
      },
      storm: {
        title: 'Буря!',
        body: 'Буря снесла каждый корабль эскадры по ветру — это и был их ход. Корабли вне эскадры остались на месте.',
      },
      fire: {
        title: 'Противник в зоне огня',
        body: 'Выберите свой корабль и нажмите на противника с красной меткой, чтобы выстрелить. Каждый выстрел попадает с вероятностью {{hitPercent}}%.',
      },
      volley: {
        title: 'Можно дать залп',
        body: '{{volleyMin}} и более кораблей могут стрелять по одной цели вместе: попадание решается один раз на всех, и при удаче все выстрелы попадают разом.',
      },
      damaged: {
        title: 'Пробоина',
        body: 'Корабль тонет, когда пробоин становится столько, сколько указано в его карточке. В своём порту его можно починить в доке.',
      },
      dock: {
        title: 'В док',
        body: 'Повреждённый корабль в своём порту может встать в док, если не стрелял в этот ход: в конце каждого вашего хода заделывается одна пробоина. В доке он не двигается и не стреляет.',
      },
      fort: {
        title: 'Под пушками форта',
        body: 'Вражеский форт бьёт по кораблям в своей дальности в ход своей стороны. Держитесь подальше или подведите несколько кораблей, чтобы его разбить.',
      },
      royalPort: {
        title: 'На Королевском порту',
        body: 'Корабль, который стоит на вражеском Королевском порту с начала до конца хода своей стороны, прибавляет к счёту один. На {{hold}} эта сторона побеждает.',
      },
    },
    topics: {
      goal: {
        title: 'Цель',
        body: 'Два флота парусников и первых пароходов сходятся на карте с гаванями, фортами и рифами. Победить можно двумя способами: потопить все корабли противника или удерживать его Королевский порт {{hold}} хода подряд.\n\nКаждый корабль и форт стоит на карте. Выберите его, чтобы открыть карточку: скорость при свежем ветре и в штиль, орудия, дальность и сколько пробоин он выдержит.',
      },
      turn: {
        title: 'Ход',
        body: 'Стороны ходят по очереди. Ваш ход — три шага.\n\n1. Выберите эскадру: нажмите на карте корабли, которые пойдут в этот ход, затем «Бросить ветер». Ветер решит, куда и как далеко они смогут пройти.\n\n2. Ходите и стреляйте в любом порядке. Выберите корабль: синие клетки — куда он может пойти, красные метки — в кого он попадёт. Стрелять могут и корабли не из эскадры.\n\n3. Нажмите «Завершить ход». Корабли в доке и на ремонте форта чинятся, засчитывается удержание вражеского Королевского порта, и ходит противник.\n\nСтрока вверху экрана всегда пишет, что делать сейчас, а круглая кнопка в правом нижнем углу выполняет этот шаг: «Бросить ветер», потом «Завершить ход».',
      },
      muster: {
        title: 'Эскадра',
        body: 'Прежде чем бросить ветер, вы называете эскадру — корабли, которые пойдут в этот ход. Нажимайте на них на карте, каждый выбранный отмечен галочкой. После ветра двигается только эскадра — и только её застигает буря.\n\nМожно никого не выбирать и сразу перейти к огню. Корабли в доке или на ремонте форта в эскадру не входят.',
      },
      wind: {
        title: 'Ветер',
        body: 'Один бросок вертушки — на всю эскадру. Он даёт направление и погоду: свежий ветер, штиль или бурю, всё с равной вероятностью.\n\nПри свежем ветре быстрее всего идти по ветру, куда указывает стрелка; каждые 45° против ветра отнимают клетку. Бриг на картинке проходит {{brigFast}} клеток по ветру и {{brigSlow}} прямо против. Гребные и паровые суда никогда не идут медленнее, чем в штиль.',
      },
      movement: {
        title: 'Движение',
        body: 'Каждый ход корабля — прямая в одном из восьми направлений, по линии или по диагонали, не дальше его хода. Суша, форты и рифы его останавливают. Сквозь другие корабли проходить можно, но закончить нужно там, где есть место: два корабля в морской клетке, один в прибрежной, не больше {{portLimit}} в порту.\n\nВ штиль двигаются только гребные и паровые суда — со скоростью штиля, в любом направлении; парусники ждут ветра. Каждый корабль ходит один раз за ход.',
      },
      storm: {
        title: 'Буря',
        body: 'Буря сносит каждый корабль эскадры по ветру на его снос — сразу и хотите вы того или нет. Снос и есть ход корабля в этот ход.\n\nКорабль, вынесенный на риф, разбивается. Прижатый к суше или к полной клетке останавливается раньше и встаёт на якорь. Корабли вне эскадры пережидают бурю на месте, поэтому у рифов маленькая эскадра надёжнее.',
      },
      fire: {
        title: 'Огонь и залп',
        body: 'Корабли и форты стреляют в любом из восьми направлений, не дальше своей дальности. Суша и форты на пути закрывают выстрел; корабли, рифы и берег — нет. Каждый выстрел попадает с вероятностью {{hitPercent}}% и даёт одну пробоину; корабль тонет, когда пробоин становится столько, сколько указано в его карточке.\n\nЗалп — это выстрелы {{volleyMin}} и более кораблей по одной цели разом. Попал залп или нет, решается один раз на всех, с той же вероятностью {{hitPercent}}%: попадание — цель получает все пробоины сразу, промах — все выстрелы пропали. Так большой корабль топят одним ударом. Неистраченные выстрелы пропадают в конце хода.',
      },
      ports: {
        title: 'Порты и док',
        body: 'Пока форт стоит, вражеские корабли не могут войти в ваш порт. Внутри своего порта корабль может перейти в любую другую его клетку без ветра — это его ход.\n\nПовреждённый корабль в своём порту может встать в док, если не стрелял в этот ход. Ход постановки не считается; затем в конце каждого вашего хода заделывается одна пробоина, а целым корабль выходит из дока. В доке он не двигается и не стреляет, но по нему можно бить, а если форт падёт, все корабли в его доке тонут.',
      },
      forts: {
        title: 'Форты',
        body: 'Форт первой линии делает {{fort1Shots}} выстрела за ход на {{fort1Range}} клеток и падает после {{fort1Hits}} попаданий; форт второй линии — {{fort2Shots}} выстрела на {{fort2Range}}, падает после {{fort2Hits}}. Форты стреляют только в ход своей стороны.\n\n{{crew}} ваших корабля в порту повреждённого форта, не стрелявших в этот ход, могут его чинить: по {{fortRepair}} попадания за ход, начиная со следующего. Павший форт оставляет свой порт открытым морем, и тот, кто починит его {{crew}} кораблями без врага в порту, поднимет над ним свой флаг.',
      },
      royal: {
        title: 'Королевский порт',
        body: 'У каждой стороны один Королевский порт, без форта. Своим кораблям входить в него нельзя, вражеским можно — по два.\n\nКорабль на вражеском Королевском порту не стреляет, но по нему стрелять можно. Если ваш корабль стоит там с начала до конца вашего хода, счёт растёт на один; если нет — начинается заново. Ход прибытия не считается. На {{hold}} вы побеждаете.\n\nБуря сносит только корабли эскадры. Не берите в эскадру корабль, который держит порт, — тогда буря его не тронет. Если же он в эскадре, буря снесёт его с порта, как любой другой, и если там не останется другого вашего корабля, счёт начнётся заново.',
      },
      end: {
        title: 'Конец игры',
        body: 'Игра кончается, когда у стороны не остаётся кораблей на плаву — потопленных и разбитых одинаково, — или когда сторона удержала вражеский Королевский порт {{hold}} хода.\n\nСторона может и сдаться в любой момент или предложить ничью: предложение действует до конца следующего хода противника. И то и другое — в меню игры. Оконченная игра остаётся в вашем судовом журнале, где можно ещё раз посмотреть её последний ход.',
      },
    },
  },
  shipsPage: {
    pageTitle: 'Корабли',
    title: 'Корабли',
    lead: 'Все классы флота: как ходят и как воюют.',
    intro:
      'У обеих сторон одинаковый флот. Класс корабля определяет, как далеко он ходит при каждой погоде и как стреляет; числа те же, что на его карточке.',
    movement: {
      title: 'Передвижение',
      body: 'Клеток за ход. При свежем ветре скорость указана строго по ветру, каждые 45° против ветра отнимают клетку; гребные и паровые суда могут вместо этого идти со скоростью штиля, если она больше. В штиль ходят только гребные и паровые. Буря сносит корабль по ветру на величину сноса.',
    },
    combat: {
      title: 'Бой',
      body: 'Каждый ход корабль делает свои выстрелы по врагам в пределах дальности и тонет, набрав столько пробоин, сколько указано в колонке «Пробоин до потопления».',
    },
    table: {
      ship: 'Корабль',
      propulsion: 'Движитель',
      guns: 'Пушки',
      inFleet: 'Во флоте',
      kinds: { sail: 'паруса', oars: 'паруса и вёсла', steam: 'паруса и пар' },
    },
  },
  credits: {
    pageTitle: 'Благодарности',
    title: 'Благодарности',
    artwork: 'Графика',
    ownArt: 'Векторные токены кораблей и графика поля нарисованы для Salt & Shot.',
    link: 'Благодарности',
  },
  footer: {
    scale: 'Морские мили',
    imprint: 'Составлено тщательно. Не для навигации.',
  },
};
